import React, {useState, useEffect} from 'react';

import './FireAndSmokeMap.css'

let screenIsTooSmallForMap = function() {
    try {
        return window.innerWidth && window.innerWidth <= 700;
    } catch(e){
        // Worst case scenario: map is loaded despite being hidden, and
        // geojson and tile resources are loaded unnecssarily
        return false;
    }
}

export default function FireAndSmokeMap(props) {
    console.log("FireAndSmokeMap - Rendering")
    const [mapUrl, setMapUrl] = useState('')

    let setMapUrlWrapper = () => {
        if (mapUrl == '' && props.isVisible && !screenIsTooSmallForMap()){
            console.log("FireAndSmokeMap - setting map url")
            if (props.covidOnly)
                setMapUrl('https://maps.airfire.org/covid_tracking/')
            else if (props.aqOnly)
                setMapUrl('https://maps.airfire.org/embed/')
            else
                setMapUrl('https://maps.airfire.org/covid/')
        }
    }

    useEffect(() => {
        window.addEventListener('resize', setMapUrlWrapper);
    })
    setMapUrlWrapper();

    return (
        <div style={{height: "100%", "paddingTop": "50px"}}>
            <div id="region-page-fire-smoke-map-iframe">
                <iframe src={mapUrl}
                    style={{width: "100%", height: "700px"}}/>
                <div style={{fontSize: "10pt"}}>
                    <b>Caption:</b><br />
                    {!props.aqOnly && (
                        <>
                            {props.covidOnly ? (
                                <p>
                                    Current COVID county infection rate indicator. based on 14
                                    day cases / 100,000 population. COVID rate levels are from CDC guidance,
                                    see <a href="https://covid.airfire.org/tracking/covid/about">COVID methdology</a> for
                                    more information. Two additional gradations of the Highest Risk category
                                    have been added to distinguish differences within this category, these
                                    are for convenience and not part of the CDC guidance.
                                </p>
                            ) : (
                                <div>
                                    <p>
                                        Current air quality and smoke plume conditions + COVID county
                                        infection rate indicator.  Note that the CDC COVID rate
                                        indictor (14 day cases / 100,000 population) category colors
                                        are similar to AQI air quality colors. County shading is COVID
                                        rate, not air quality category.
                                    </p>
                                    <p>
                                        COVID levels are from CDC guidance,
                                        see <a href="https://covid.airfire.org/tracking/covid/about">COVID methdology</a> for
                                        more information. Two additional gradations of the Highest
                                        Risk category have been added to distinguish differences within
                                        this category, these are for convenience and not part of the CDC guidance.
                                    </p>
                                </div>

                            )}
                            <div>
                                COVID rate coloring (based on 14 day cases / 100,000 population) is:
                                <ul>
                                    <li>Green = Lowest Risk (&lt;5)</li>
                                    <li>Light Green = Low Risk (5 to &lt;20)</li>
                                    <li>Yellow = Moderate Risk (20 to &lt;50)</li>
                                    <li>Light Red = Higher Risk (50 to &lt;200)</li>
                                    <li>Red = Highest Risk (200+), further divided into:
                                        <ul>
                                            <li>Highest Risk (200 to &lt;500)</li>
                                            <li>Highest Risk (2.5x) (500 to &lt;1000)</li>
                                            <li>Highest Risk (5x) (1000+)</li>
                                        </ul>
                                    </li>
                                </ul>
                                A few counties do not report COVID results independently and are therefore shaded grey.
                            </div>
                        </>
                    )}
                    {! props.covidOnly && (
                        <p>
                            Current air quality and smoke conditions indicators are explained in the
                            AirNow Fire and Smoke Map help section (click the ? in the upper right
                            and select User's Guide).
                        </p>
                    )}
                </div>
            </div>
            <div id="region-page-fire-smoke-map-link">
                Click
                <a href={mapUrl}> here </a>
                to see a map of current conditions.
            </div>
        </div>
    )
}
